import React, { useState } from 'react'
import productLogo from '../../assets/logos/product_logo.png' // Import your logo file
import LogoutIcon from '../../assets/icons/logout_icon.png' // Path to your logout icon
import HelpIcon from '../../assets/icons/help_icon.png' // Path to your help icon
import DeleteProfileIcon from '../../assets/icons/delete_profile_icon.png' // Path to your help icon
import Logout from '../layout/Logout'
import { GoogleOAuthProvider } from '@react-oauth/google'
import AlertMessage from './AlertMessage'
import {
  clearDiagnosticsLLM,
  clearProductLLM,
  clearSavedProduct,
  clearHairMask,
  resetApp,
  persistor,
} from '../../store'
import { useDispatch, useSelector } from 'react-redux' // Import useDispatch hook
import axios from 'axios'
import { CiUser, CiChat1 } from 'react-icons/ci'

const Header = ({
  goToDisplayVideo,
  disableHeader,
  goToAuthorisation,
  goToUserProfile,
  goToPricing,
  goToChatbot,
  goToDirectToStore,
  goToDesignPreview,
}) => {
  const [showMenu, setShowMenu] = useState(false)
  const consent_flag = useSelector((state) => state.consent_flag)
  const [showAlert, setShowAlert] = useState(false)
  const agent_id = useSelector((state) => state.agent_id)
  const dispatch = useDispatch() // Initialize dispatch function
  // Get distributor info from Redux state
  const distributor_info = useSelector((state) => state.distributor_info) || []
  // Extract the distributor logos and details
  const distributors = distributor_info.distributor_info || []
  const logo = distributors?.[0]?.['Distributor Logo'] || ''
  const agentData = useSelector((state) => state.agentData)

  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID
  const language = useSelector((state) => state.language) // Get language from Redux store
  const translations = useSelector((state) => state.translationsData) || {}
  const environment = process.env.REACT_APP_ENV
  const trial_end_date = process.env.REACT_APP_TRIAL_END_DATE
  const is_trial = process.env.REACT_APP_TRIAL_STATUS
  const [deleteProfileConfirmation, setDeleteProfileConfirmation] =
    useState(false)
  const [deleteProfileStoreAlert, setDeleteProfileStoreAlert] = useState(false)
  const [deleteProfileFailure, setDeleteProfileFailure] = useState(false)

  const getTranslationText = (
    keyPath,
    data = translations,
    lang = language.toUpperCase(),
  ) => {
    const keys = keyPath.split('.') // Split the keyPath into an array of keys

    // Traverse the data object using the keys
    let result = data
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i]

      // Handle arrays (e.g., intro or questions)
      if (Array.isArray(result)) {
        const found = result.find((item) => item.label === key)
        if (!found) {
          return undefined // Return undefined if the label is not found
        }
        result = found
      } else if (result[key] === undefined) {
        return undefined // Return undefined if the path is not found
      } else {
        result = result[key]
      }
    }

    // If the result is an object with language keys, return the active language value.
    // If the active language is missing, fall back to the first available language.
    if (typeof result === 'object' && !Array.isArray(result)) {
      const supportedLangs = ['EN', 'FR', 'NL', 'SW']
      const orderedLangs = [lang, ...supportedLangs.filter((item) => item !== lang)]

      for (const candidate of orderedLangs) {
        if (result[candidate] !== undefined) {
          return result[candidate]
        }
      }

      return ''
    }

    // Otherwise, return the result as is
    return result
  }

  const confirmAlert = getTranslationText(
    'filterProduct.confirmationAlert.alert.text',
  )
  const confirmAlertText = getTranslationText(
    'filterProduct.confirmationAlert.alert.subtext',
  )
  const logoutIconText = getTranslationText('header.logoutIconText')
  const helpIconText = getTranslationText('header.helpIconText')
  const deleteProfileIconText = getTranslationText(
    'header.deleteProfileIconText',
  )
  const deleteProfileConfirmationText = getTranslationText(
    'header.deleteProfileConfirmationText',
  )
  const deleteProfileStoreAlertText = getTranslationText(
    'header.deleteProfileStoreAlertText',
  )
  const deleteProfileFailureText = getTranslationText(
    'header.deleteProfileFailureText',
  )

  const menuUserProfile = getTranslationText('menu.userProfile')
  const menuChat = getTranslationText('menu.chat')
  const menuPricing = getTranslationText('menu.pricing')
  const menuDirectory = getTranslationText('menu.directory')

  const goToHelp = () => {
    setShowMenu(false)
  }

  const goToDeleteProfile = () => {
    setShowMenu(false)
    setDeleteProfileConfirmation(true)
  }

  const deleteProfile = () => {
    setShowMenu(false)
    const resolvedAgentId = [agent_id, agentData?.agent_id, agentData?.agentID]
      .map((value) =>
        typeof value === 'string'
          ? value.trim().toLowerCase() === 'null' ||
            value.trim().toLowerCase() === 'undefined'
            ? null
            : value
          : value,
      )
      .find((value) => value)
    if (!resolvedAgentId) {
      console.error('deleteProfile failed: missing agent_id', {
        agent_id,
        agentData,
      })
      setDeleteProfileFailure(true)
      return
    }

    const data = {
      agent_id: resolvedAgentId,
      env: environment || 'Prd',
      is_trial: is_trial || 'False',
    }

    axios
      .post(
        'https://hal-cos-prd-gwc-fnapp-v1.azurewebsites.net/api/deleteprofile',
        data,
        {
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
          },
        },
      )
      .then(async (response) => {
        const res = response.data

        const success =
          res?.status === 'success' ||
          res?.status === true ||
          res?.success === 'success' ||
          res?.success === true

        if (success) {
          dispatch(resetApp())
          await persistor.purge()
          if (typeof window !== 'undefined') {
            window.localStorage.clear()
            window.sessionStorage.clear()
          }
          goToAuthorisation()
        } else {
          console.error('deleteProfile returned non-success:', res)
          setDeleteProfileFailure(true)
        }
      })
      .catch((err) => {
        console.error(
          'deleteProfile request error',
          err?.response?.data || err.message,
        )
        setDeleteProfileFailure(true)
      })
  }

  const handleLogoutOptionClick = () => {
    setShowMenu(false) // Close the menu after clicking on an item
    setShowAlert(true)
  }
  const handleGotoDirectToStore = () => {
    setShowMenu(false) // Close the menu after clicking on an item
    goToDirectToStore() // Navigate to the Direct To Store page
  }

  const handleHalisiLogoClick = () => {
    dispatch(clearProductLLM())
    dispatch(clearDiagnosticsLLM())
    dispatch(clearSavedProduct())
    dispatch(clearHairMask())
    goToDisplayVideo()
  }

  const toggleMenu = () => {
    setShowMenu(!showMenu)
  }

  const onLogoutSuccess = () => {
    dispatch(clearProductLLM())
    dispatch(clearDiagnosticsLLM())
    dispatch(clearSavedProduct())
    dispatch(clearHairMask())
    goToAuthorisation()
  }

  if (disableHeader) {
    return null // Return null to disable rendering of the Header component
  }

  const handleShowUserProfile = () => {
    setShowMenu(false) // Close the menu after clicking on an item
    goToUserProfile() // Navigate to the user profile page
  }

  const handleShowPricing = () => {
    setShowMenu(false) // Close the menu after clicking on an item
    // Implement navigation to the pricing page if needed
    //goToPricing() // Navigate to the pricing page
  }
  const handleShowChatbot = () => {
    setShowMenu(false) // Close the menu after clicking on an item
    goToChatbot() // Navigate to the chatbot page
  }

  return (
    <div className='header'>
      <div className='header-logo' onClick={handleHalisiLogoClick}>
        {productLogo ? (
          <img
            src={productLogo}
            alt='Distributor Logo'
            className='header-logo-image'
          />
        ) : null}
      </div>
      {agentData?.status !== 'User' && logo && (
        <div className='header-logo header-distributor-logo'>
          {/* Uncomment and use distributor logo if desired */}
          {/* <img
            src={`data:image/png;base64,${logo}`}
            alt='Distributor Logo'
            className='header-logo-image'
          /> */}
        </div>
      )}

      <h1 className='app-title'>Halisi Cosmetics</h1>
      {/* App title */}
      {/* Logout button */}
      <div className='header-container'>
        <div className='logout-button'>
          <GoogleOAuthProvider clientId={googleClientId}>
            <Logout goToAuthorisation={goToAuthorisation}></Logout>
          </GoogleOAuthProvider>
        </div>
        <div className='menu'>
          {/* Hamburger menu icon */}
          <div className='hamburger-menu' onClick={toggleMenu}>
            &#9776;
          </div>
          {/* Dropdown menu */}
          {showMenu && (
            <div className='dropdown-menu'>
              <div className='menu-item help' onClick={goToHelp}>
                <span>{helpIconText}</span>
                <img src={HelpIcon} alt='Help Icon' className='menu-icon' />
              </div>

              <div className='menu-item help' onClick={handleShowUserProfile}>
                <span>{menuUserProfile}</span>
                <CiUser size={24} className='menu-icon' />
              </div>
              <div className='menu-item help' onClick={handleShowChatbot}>
                <span>{menuChat}</span>
                <CiChat1 size={24} className='menu-icon' />
              </div>

              <div
                className='menu-item help'
                onClick={() => {
                  setShowMenu(false)
                  goToDesignPreview?.()
                }}
              >
                <span>Card Preview</span>
                <CiUser size={24} className='menu-icon' />
              </div>

              <div className='menu-item help' onClick={handleShowPricing}>
                <span>{menuPricing}</span>
                {/* <CiUser size={24} className='menu-icon' /> */}
              </div>
              <div className='menu-item help' onClick={handleGotoDirectToStore}>
                <span>{menuDirectory}</span>
                {/* <CiUser size={24} className='menu-icon' /> */}
              </div>
              <div className='menu-item help' onClick={goToDeleteProfile}>
                <span>{deleteProfileIconText}</span>
                <img
                  src={DeleteProfileIcon}
                  alt='Help Icon'
                  className='menu-icon'
                />
              </div>
              <div
                className='menu-item logout'
                onClick={handleLogoutOptionClick}
              >
                <span>{logoutIconText}</span>
                <img src={LogoutIcon} alt='Logout Icon' className='menu-icon' />
              </div>
              {/* Add more menu items as needed */}
            </div>
          )}
        </div>
      </div>
      {showAlert && (
        <AlertMessage
          message={confirmAlert}
          subtext={confirmAlertText}
          onConfirm={() => {
            dispatch(clearProductLLM())
            dispatch(clearDiagnosticsLLM())
            dispatch(clearSavedProduct())
            setShowAlert(false)
            goToAuthorisation() // Handle logout functionality (passed as a prop)
          }}
          onCancel={() => {
            setShowAlert(false)
          }}
        />
      )}
      {deleteProfileConfirmation && (
        <AlertMessage
          message={deleteProfileConfirmationText}
          onConfirm={() => {
            setDeleteProfileConfirmation(false)
            deleteProfile()
          }}
          onCancel={() => {
            setDeleteProfileConfirmation(false)
          }}
        />
      )}
      {deleteProfileStoreAlert && (
        <AlertMessage
          message={deleteProfileStoreAlertText}
          onConfirm={() => {
            setDeleteProfileStoreAlert(false)
            goToAuthorisation() // Handle logout functionality (passed as a prop)
          }}
        />
      )}
      {deleteProfileFailure && (
        <AlertMessage
          message={deleteProfileFailureText}
          onConfirm={() => {
            setDeleteProfileFailure(false)
            goToAuthorisation() // Handle logout functionality (passed as a prop)
          }}
        />
      )}
    </div>
  )
}

export default Header
